function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.558 1a.5.5 0 01.325.12l7.942 6.799a.5.5 0 01.175.38V21.5a.5.5 0 01-.5.5h-16a.5.5 0 01-.5-.5v-20a.5.5 0 01.5-.5h8.058zM11 4H7v15h11V9.449h-7V4z",
  fill: "#444",
  fillRule: "nonzero"
});

function SvgIcDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgIcDescription;